import { createSelector } from "../../../utils/createSelector.js";
export var gridColumnResizeSelector = function(state) {
    return state.columnResize;
};
export var gridResizingColumnFieldSelector = createSelector(gridColumnResizeSelector, function(columnResize) {
    return columnResize.resizingColumnField;
});
